import { Vue } from 'vue-property-decorator'
import { ApiResponseActivateLogin } from '@/api/responses/activate/login'

export namespace LoginApi {
  /**
   * 仮ユーザログイン
   *
   * @param uid ログインID
   * @param password パスワード
   * @returns 認証情報
   */
  export async function login(uid: string, password: string): Promise<ApiResponseActivateLogin> {
    const params = {
      uid: uid,
      password: password,
    }
    const res = await Vue.prototype.$http.post('/activate/sign_in', params)
    return res.data
  }
}
